import { FitpetMallEventEnum } from '@/constants/fitpet-mall-event.enum'
import { useTracker } from '@/containers/contexts/EventTrackingProvider'
import { ProductTypeDefinedByFrontend } from '@/types/product-type-defined-by.frontend'

export const useHomeNewProductTracker = () => {
  const tracker = useTracker()
  const trackClickHomeNewProductEvent = ({ product }: { product: ProductTypeDefinedByFrontend }) => {
    const properties = {
      productId: product.id,
      productName: product.name,
      productPrice: product.price,
      productDiscountRate: product.discountRate,
      productPurchasePrice: product.salePrice,
      productReviewAvgScore: product.reviewScore,
      productReviewTotalCount: product.reviewCount,
      productIsInStock: !product.isRealSoldOut,
    }

    tracker.triggerCustomEvent(FitpetMallEventEnum.ClickHomeNewProduct, properties)
  }
  return { trackClickHomeNewProductEvent }
}
